import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { border } from 'styled-system';

import { Box } from '@hivebrite/design-system/Box';
import { focusOutline } from '@hivebrite/design-system/Theme';

import IconCheck from 'hb-react/shared/icons/Check';
import onEnterOrSpacePress from 'hb-react/shared/utils/onEnterOrSpacePress';

/**
 * @deprecated please use `@hivebrite/design-system/Inputs` instead
 */
const Checkbox = ({
  id,
  hideLabel,
  checked,
  onChange,
  label,
  name,
  disabled,
}) => (
  <Box>
    <Wrapper
      checked={checked}
      tabIndex={disabled ? -1 : 0}
      onKeyPress={onEnterOrSpacePress(onChange)}
      disabled={disabled}
    >
      {checked && <Icon />}
      <Input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        tabIndex={-1}
        name={name}
        disabled={disabled}
      />
    </Wrapper>
    <LabelWrapper hideLabel={hideLabel} disabled={disabled}>
      <Label htmlFor={id} disabled={disabled}>
        {label}
      </Label>
    </LabelWrapper>
  </Box>
);

Checkbox.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  hideLabel: PropTypes.bool,
  name: PropTypes.string,
};

Checkbox.defaultProps = {
  hideLabel: false,
  disabled: false,
};

export default Checkbox;

const Wrapper = styled(Box)
  .withConfig({
    shouldForwardProp: (prop) =>
      !['borderColor', 'borderRadius', 'disabled'].includes(prop),
  })
  .attrs(({ theme, checked, disabled }) => ({
    color: 'white',
    bg: checked
      ? theme.checkbox.background.checked
      : theme.checkbox.background.unchecked,
    borderColor: theme.checkbox.border.color,
    borderRadius: theme.checkbox.border.radius,
    opacity: disabled ? 0.6 : 1,
  }))`
  border: 1px solid;
  flex-shrink: 0;
  height: ${(props) => props.theme.space[5]}px;
  width: ${(props) => props.theme.space[5]}px;
  position: relative;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  ${border}
  ${focusOutline}
`;

const LabelWrapper = styled(({ hideLabel, ...props }) => (
  <Box {...props} />
)).attrs(({ disabled }) => ({
  pl: 2,
  opacity: disabled ? 0.6 : 1,
}))`
  align-items: center;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  ${(props) =>
    props.hideLabel &&
    css`
      border: 0px !important;
      clip: rect(0 0 0 0) !important;
      clip-path: inset(100%) !important;
      height: 1px !important;
      overflow: hidden !important;
      padding: 0px !important;
      position: absolute !important;
      white-space: nowrap !important;
      width: 1px !important;
    `};
`;

const Icon = styled(IconCheck)`
  position: absolute;
`;

const Input = styled.input`
  height: 100%;
  width: 100%;
  opacity: 0;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

const Label = styled.label.withConfig({
  shouldForwardProp: (prop) => !['disabled'].includes(prop),
})`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;
